module.exports = __webpack_public_path__ + "img/分类找款ico.594b78e3.png";